module.exports = __webpack_public_path__ + "img/solar-panel.1c9ce190.png";